export default __webpack_public_path__ + "static/media/spiritofnightfall.bcd79508.png";